import { Layout } from '@/views/order-log';

export default {
    path: '/order-log',
    component: Layout,
    children: [
        { path: '', component: () => import('@/views/order-log/OrderLog.vue') },
    ]
};
